import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { mq } from "../../Theme";
import { mapColor } from "../textUtils";
var getCss = function(size) {
    switch(size){
        case "small":
            return /*#__PURE__*/ css("font-size:", "0.938rem", ";line-height:", "1.6em", ";", mq("lg"), "{font-size:", "1rem", ";line-height:", "1.25em", ";}");
        case "xs":
            return /*#__PURE__*/ css("font-size:", "0.75rem", ";line-height:", "1.5em", ";", mq("lg"), "{font-size:", "0.875rem", ";line-height:", "1.429em", ";}");
        default:
            return /*#__PURE__*/ css("font-size:", "1.125rem", ";line-height:", "1.333em", ";");
    }
};
var interactiveText = function(param) {
    var textColor = param.textColor, theme = param.theme, _size = param.size, size = _size === void 0 ? "normal" : _size;
    return /*#__PURE__*/ css("font-family:", theme.fontFamily.alternate, ";font-weight:700;color:", mapColor(theme, textColor), ";", getCss(size));
};
var InteractiveWrapper = /*#__PURE__*/ styled("p", {
    target: "e9o9emm0"
})(interactiveText);
var InteractiveInlineWrapper = /*#__PURE__*/ styled("span", {
    target: "e9o9emm1"
})(interactiveText);
export { interactiveText, InteractiveWrapper, InteractiveInlineWrapper };
